module.exports = __webpack_public_path__ + "images/231c892483533873eceb4e76c8539b29-wave.png";